import { useEffect, useRef, useState } from 'react';
import { createRoot } from 'react-dom/client';

import _kebabCase from 'lodash/kebabCase';

import CopyToClipboard from '@components/CopyToClipboard/CopyToClipboard';

import Styles from './TextContent.module.scss';

const reduceHeadings = (result, item) => {
  if (item.type === 'heading-two') {
    result.push({ title: item.title, target: item.target, children: [] });
  } else if (item.type === 'heading-three') {
    result[result.length - 1].children.push({ title: item.title, target: item.target });
  }
  return result;
};

const getTableOfContents = ({ title, headings }) => (
  <div className={Styles.tableOfContents}>
    <h2 id={_kebabCase(title)} className={Styles.tocTitle}>
      {title}
    </h2>
    <ol>
      {headings?.map((heading, index) => (
        <li key={index}>
          <a href={`#${heading.target}`}>{heading.title}</a>
          {!heading.children?.length ? null : (
            <ol>
              {heading.children?.map((child, index) => (
                <li key={index}>
                  <a href={`#${child.target}`}>{child.title}</a>
                </li>
              ))}
            </ol>
          )}
        </li>
      ))}
    </ol>
  </div>
);

const BaseRichText = ({ allHeadings, showCopyButton, dangerouslySetInnerHTML: { __html } }) => {
  const parentElement = useRef();
  const [isParentReady, setIsParentReady] = useState(false);
  const [tocTitle, setTocTitle] = useState();

  useEffect(
    () => setIsParentReady(!!parentElement?.current),
    [parentElement, parentElement?.current]
  );
  useEffect(() => {
    if (isParentReady && __html) {
      const elems = parentElement?.current?.querySelectorAll('h2, h3');
      elems?.forEach((el) => el?.setAttribute('id', _kebabCase(el?.textContent)));

      const toc = parentElement?.current?.querySelector('.toc');
      if (!toc) return;

      // This is stored for the next time the hook runs. Recall wouldn't work the first
      // time due to async set function. So the same value is set default with `||`.
      if (!tocTitle) setTocTitle(toc.textContent);
      const title = tocTitle || toc.textContent;

      const headings = allHeadings.reduce(reduceHeadings, []);
      const tableOfContents = getTableOfContents({ title, headings });
      createRoot(toc).render(tableOfContents);
    }
  }, [__html, isParentReady]);

  return (
    <div className={Styles.baseRichText}>
      {showCopyButton && (
        <CopyToClipboard className={Styles.copyToClipboard} forRef={parentElement.current} />
      )}
      <div ref={parentElement} dangerouslySetInnerHTML={{ __html }} />
    </div>
  );
};

export default BaseRichText;
